<template>
  <div class="section-sub-event" id="section-sub-event" data-aos="fade-up" data-aos-once="true">

    <!-- header -->
    <page-subheader :title="paragraph.title"></page-subheader>

    <div-container>
      <div class="columns is-gapless is-centered" v-if="imageUrl">
        <div class="column is-3 has-text-centered content content-image">
          <img :src="imageUrl" width="200" style="width:100%;padding:30px;" />
        </div>
        <div class="column is-8 has-text-left content" :class="{ 'with-image': imageUrl !== undefined }" v-html="paragraph.content" />
      </div>
      <!-- <div class="control notification is-danger" v-if="error">
        <button class="delete" @click="error = undefined"></button>
        <p v-html="error">
        </p>
      </div> -->

    </div-container>
  </div>
</template>

<script>
// import Site from '@/apis/Site'
import DivContainer from '@/components/DivContainer'
import PageSubheader from '@/components/PageSubheader'
import ShowDown from 'showdown'
import 'showdown-target-blank'

export default {
  name: 'sub-event',
  props: ['slug', 'title', 'item'],
  components: {
    DivContainer,
    PageSubheader
  },
  data () {
    return {
      paragraph: {
        title: '',
        content: ''
      },
      imageUrl: undefined,
      error: undefined,
      loading: false
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name)
    }.bind(this),

    getItems: function (onComplete) {
      // this.loading = true
      // this.error = undefined
      // this.imageUrl = undefined
      // this.paragraph.content = ''
      // this.paragraph.title = ''
      // Site.eventWithSlug(this.slug)
      // .then((data) => {
      //   this.loading = false
      //   // console.log(data)
      //   if (!data || !data.content) {
      //     this.error = 'Unable to load, please kindly refresh the page.'
      //     return
      //   }
      //
      //   var converter = new ShowDown.Converter({ extension: ['targetblank'] })
      //   var html = converter.makeHtml(data.content)
      //   this.paragraph.content = html
      //   this.paragraph.title = data.title
      //   this.imageUrl = data.image.path
      //
      //   if (onComplete) {
      //     onComplete(data)
      //   }
      // })
      // .catch((error) => {
      //   this.loading = false
      //   this.error = 'Unable to load, please kindly refresh the page.'
      //   console.log(error)
      // })
    },

    refresh: function () {
      // this.getItems((item) => {
      //   this.item = item
      // })

      var converter = new ShowDown.Converter({ extension: ['targetblank'] })
      var html = converter.makeHtml(this.item.description)
      this.paragraph.content = html
      this.paragraph.title = this.item.title
      this.imageUrl = this.item.image.path
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// section sub event

.section-sub-event {
  padding-top: 3rem;
  padding-bottom: 3rem;

  .title:not(:last-child),
  .subtitle:not(:last-child) {
    padding-left: 0.75em;
    padding-right: 0.75em;
    margin-bottom: 0.1em;
  }

  .title:last-child,
  .subtitle:last-child {
    padding-left: 0.75em;
    padding-right: 0.75em;
    margin-bottom: 1em;
  }

  p {
    font-size: 1em;
    text-align: left;
    padding-left: 0.75em;
    padding-right: 0.75em;

    &:not(:first-child) {
      margin-top: 1em;
      @media screen and (min-width: $tablet) {
        margin-top: 1em;
      }
    }
  }

  .columns.is-gapless:not(:last-child) {
    margin-bottom: 0;
  }

  .columns.is-gapless > .column {
    &.content {
      // background-color: white;
      padding: 30px 15px;

      @media screen and (min-width: $tablet) {
        padding: 30px 50px;
        padding-left: 0;
      }

      &.content-image {
        padding: 10px;

        @media screen and (min-width: $tablet) {
          padding: 10px 30px;
          padding-right: 0;
        }
      }

      img {
        display: block;
        margin-left: auto;
        margin-right: auto;
      }

      p, li, h1, h2, h3, h4, h5, h6, strong {
        color: $color-darkbrown;
      }

      p, li {
        line-height: 2.2em;
      }

      h1, h2, h3, h4, h5, h6 {
        font-family: $font-family-title;
        font-weight: bold;
        text-transform: uppercase;

        // &:not(:first-child) {
        //   margin-top: 2rem;
        // }
        // margin-bottom: 1rem;
        //
        // @media screen and (min-width: $tablet) {
        //   &:not(:first-child) {
        //     margin-top: 3rem;
        //   }
        //   margin-bottom: 2rem;
        // }

        &:not(:first-child) {
          margin-top: 0;
        }

        a {
          margin-left: 30px;
        }
      }

      h1, h2 {
        &:not(:first-child) {
          margin-top: 3rem;
        }
      }
    }
  }

  ul {
    list-style: disc;
    margin-left: 2em;
  }
}

</style>



// WEBPACK FOOTER //
// EventSubSection.vue?15751d1c